import './consultamodal.css';
import React, { useState, useEffect } from 'react';
import Services from '../../../Content/Services';

const ConsultaModal = ({ open, onClose }) => {
  const [step, setStep] = useState(2);
  const [fuero, setFuero] = useState('');
  const [urgencia, setUrgencia] = useState('');
  const [pago, setPago] = useState('');
  const [consulta, setConsulta] = useState('');

  const clearPersistedData = () => {
    localStorage.removeItem('consultaData');
    setFuero('');
    setUrgencia('');
    setPago('');
    setConsulta('');
    setStep(2);
  };

  const handleClose = () => {
    clearPersistedData();
    if (onClose) onClose();
  };

  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('consultaData'));
    if (savedData) {
      setFuero(savedData.fuero || '');
      setUrgencia(savedData.urgencia || '');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('consultaData', JSON.stringify({ fuero, urgencia }));
  }, [fuero, urgencia]);

  const canContinue = () => {
    if (step === 2) return fuero !== '';
    if (step === 3) return urgencia !== '';
    if (step === 4) return pago !== '';
    return false;
  };

  const canSendWhatsApp = () => true; 

  const handleEnviarWhatsapp = () => {
    const phone = '5491161937832';
    const msg =
      `Hola Masini Asociados, ¿cómo están? ` +
      `Quería hacer una consulta del fuero: ${fuero || 'desconozco el fuero'}, por un tema de urgencia ${urgencia || 'sin urgencia'}. ` +
      (consulta ? `\n\nDetalle: ${consulta}\n` : '') +
      `Desde ya muchas gracias.`;

    const urlApi = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(msg)}`;

    const urlWaMe = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;

    window.location.href = urlApi;

    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.location.href = urlWaMe;
      }
      setTimeout(handleClose, 200);
    }, 400);
  };

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">

        {step === 2 && (
          <>
            <h3>¿Sobre qué fuero vincula su consulta?</h3>
            <select value={fuero} onChange={(e) => setFuero(e.target.value)}>
              <option value="">Seleccione una Opción</option>
              <option value="Desconozco el fuero">Desconozco el fuero</option>
              {Services.map((s) => (
                <option key={s.ID} value={s.Name}>{s.Name}</option>
              ))}
            </select>
            <div className="modal-buttons">
              <button className="btn-cancelar" onClick={handleClose}>Cancelar</button>
              <button className="btn-continuar" onClick={nextStep} disabled={!canContinue()}>
                Continuar
              </button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <h3>¿Es un tema de urgencia?</h3>
            <select value={urgencia} onChange={(e) => setUrgencia(e.target.value)}>
              <option value="">Seleccione una Opción</option>
              <option value="Baja">Baja</option>
              <option value="Media">Media</option>
              <option value="Alta">Alta</option>
            </select>
            <div className="modal-buttons">
              <button className='btn-atras' onClick={prevStep}>Atrás</button>
              <button className="btn-continuar" onClick={nextStep} disabled={!canContinue()}>
                Continuar
              </button>
            </div>
          </>
        )}

        {step === 4 && (
          <>
            <h3>¿Está dispuesto/a a abonar por una consulta?</h3>
            <div className="opciones-radio">
              <label>
                <input
                  type="radio"
                  value="Sí"
                  checked={pago === 'Sí'}
                  onChange={(e) => setPago(e.target.value)}
                />
                Sí
              </label>
              <label>
                <input
                  type="radio"
                  value="No"
                  checked={pago === 'No'}
                  onChange={(e) => setPago(e.target.value)}
                />
                No
              </label>
            </div>
            <div className="modal-buttons">
              <button className='btn-atras' onClick={prevStep}>Atrás</button>
              <button className="btn-continuar" onClick={nextStep} disabled={!canContinue()}>
                Continuar
              </button>
            </div>
          </>
        )}

        {step === 5 && pago === 'Sí' && (
          <>
            <h3>Envíanos tu consulta por WhatsApp</h3>
            <div className='Modal-btn-Wapp'>
              <button className="btn-wapp" onClick={handleEnviarWhatsapp} disabled={!canSendWhatsApp()}>
                Contactar por WhatsApp
              </button>
            </div>  
            <div className="modal-buttons">
              <button className='btn-atras' onClick={prevStep}>Atrás</button>
              <button className='btn-cerrar' onClick={handleClose}>Cerrar</button>
            </div>
          </>
        )}

        {step === 5 && pago === 'No' && (
          <div className='Modal-Gracias'>
            <h3>Gracias por su tiempo.</h3>
            <div className="modal-buttons-NO">
              <button className='btn-cerrar' onClick={handleClose}>Cerrar</button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default ConsultaModal;
